import { Check, FileText } from "lucide-react";
import { Chip } from "@/components/grooming/grooming-chips";
import { BRIEF_STATE_TONES, BRIEF_STATE_WORDS, type BriefState } from "@/lib/grooming/plain-words";

/**
 * A brief's state in the shared words (epic PI-SPEC-SW-E289, UX-PM-09): Brief
 * not posted, Brief posted, Brief held back or Brief out of date. The words
 * and tones come from plain-words.ts so every screen says the same thing.
 */
export function BriefStateChip({
  state,
  className,
  testId = "brief-state-chip",
}: {
  state: BriefState;
  className?: string | undefined;
  testId?: string;
}) {
  return (
    <Chip tone={BRIEF_STATE_TONES[state]} testId={testId} dataState={state} {...(className ? { className } : {})}>
      {state === "not-posted" && <FileText className="h-3 w-3" aria-hidden="true" />}
      {state === "posted" && <Check className="h-3 w-3" aria-hidden="true" />}
      {BRIEF_STATE_WORDS[state]}
    </Chip>
  );
}
